/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 19:27:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/Carousel/index.tsx
 */
import React from 'react';

import _Carousel from 'src/components/Modules/Carousel';

import ContentGroupHOC from '../HOC';
import { compose } from 'redux';

const Carousel = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
  } = props || {};
  // console.log('carousel linkSet', linkSet);

  return (
    <_Carousel
      staticData={staticData}
      linkModules={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={specificError}
      droppableId={droppableId}
    />
  );
};
export default compose(ContentGroupHOC)(Carousel);
